export enum AuditFormFrequencyEnum {
  ADHOC = 'AD-HOC',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY='QUARTERLY',
  YEARLY = 'YEARLY'
}
